import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import axiosBackEnd from "../../config/axios/axios-back-end";
import _ from "lodash";

import { Collapse, message } from "antd";

import FormOne from "../../components/Users/UserInvitation/FormOne";
import TableOne from "../../components/Users/UserInvitation/TableOne";

const { Panel } = Collapse;

class UserInvitation extends Component {
  state = {
    dataOne: null,
    dataTwo: null,
  };

  formOneFormRef = React.createRef();

  async componentDidMount() {
    await this.props.userListGet();
  }

  getDataOne = async (data) => {
    this.props.apiStart();
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const response = await axiosBackEnd.get("/api/users/user-invitation", {
        params: data,
        headers: headers,
      });
      if (response && response.data) {
        if (response.data.data_1) {
          this.setState({ dataOne: response.data.data_1 });
          this.formOneFormRef.current.setFieldsValue({
            email: response.data.data_1.email
              ? response.data.data_1.email
              : null,
            password_reset: response.data.data_1.welcome_reset_status
              ? true
              : false,
          });
          if(response.data.data_1.welcome_reset_status && data.show_message){
            message.success("User account already activated.");
          }
        }
        if (response.data.data_2) {
          this.setState({ dataTwo: response.data.data_2 });
        }
      }
      this.props.apiComplete();
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
      } else {
        message.error(err.message);
      }
      this.props.apiComplete();
      console.log("Eroor: ", err);
    }
  };

  userIdOnChange = async (value) => {
    if (value) {
      this.getDataOne({ user_id: value, show_message : true });
    } else {
      this.setState({ dataOne: null, dataTwo: null });
      this.formOneFormRef.current.setFieldsValue({ email: null });
    }
  };

  formOneOnFinish = async (data) => {
    this.props.apiStart();
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const response = await axiosBackEnd.post(
        "/api/users/add-user-invitation",
        data,
        {
          headers: headers,
        }
      );
      if (response.data) {
        if (this.state.dataOne && this.state.dataOne._id) {
          this.getDataOne({ user_id: this.state.dataOne._id });
        }
        message.success(response.data.message);
      } else {
        console.log("Eroor: ", response);
      }
      this.props.apiComplete();
    } catch (err) {
      if (err.response) {
        const errors = err.response.data.errors;
        if (errors) {
          errors.forEach((error) => message.error(error.msg));
        }
      } else {
        message.error(err.message);
      }
      this.props.apiComplete();
      console.log("Eroor: ", err);
    }
  };

  render() {
    return (
      <div>
        <div className="container_ab">
          <div className="container_style_2">
            <Collapse defaultActiveKey={["1_1"]} expandIconPosition="end">
              <Panel header="User Invitation" key="1_1" arrow="right">
                <div className="is_form_1">
                  {this.props.api.userListGetData ? (
                    <FormOne
                      formRef={this.formOneFormRef}
                      userListGetData={this.props.api.userListGetData.data}
                      userIdOnChange={this.userIdOnChange}
                      formOneOnFinish={this.formOneOnFinish}
                      dataOne={this.state.dataOne}
                    />
                  ) : null}
                </div>
              </Panel>
            </Collapse>

            <div style={{ marginBottom: 20 }}></div>

            {this.state.dataTwo && this.state.dataTwo.length > 0 ? (
              <TableOne tableOneData={this.state.dataTwo} />
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    api: state.api,
  };
};

const mapDispatchToProps = (dispatch) => ({
  userListGet: () => dispatch(actions.userListGet()),
   apiStart: (data) => dispatch(actions.apiStart(data)),
  apiComplete: (data) => dispatch(actions.apiComplete(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserInvitation);
